import React from "react";
import styles from "./About.module.css";
import worldMap from "../../Assests/Images/globalPartner2.png";
import globalPartner from "../../Assests/Images/globalPartner1.png";




const GlobalPartner = () => {
  return (
    <div className={styles.globalPartnerSection}>
      <div className={styles.globalPartnerContainer}>
        {/* Section 1 */}
        <div className={styles.globalSection}>
          <div className={styles.globalContent}>
            <h2 className={styles.globalHeading}>
              A Global Partner. Committed to Excellence.
            </h2>
            <p className={styles.globalText}>
              At Hyproc International, we don’t just supply products we build
              solutions that drive efficiency, cost savings, and operational
              success. Whether handling small-scale orders or complex,
              large-scale projects, we deliver with precision and expertise.
            </p>
          </div>
          <div className={styles.globalImageWrapper}>
            <img
              src={globalPartner}
              alt="Global Partner"
              className={styles.globalImage}
              style={{ borderRadius: "20px 0px 0px 20px" }} // Added border-radius for the first section
            />
          </div>
        </div>

        {/* Section 2 */}
        <div className={styles.globalSection}>
          <div className={styles.globalImageWrapper}>
            <img
              src={worldMap}
              alt="Our Mission"
              className={styles.globalImage}
              style={{ borderRadius: "0px 20px 20px 0px" }} // Added border-radius for the second section
            />
          </div>
          <div className={styles.globalContent}>
            <h2 className={styles.globalHeading}>Our Mission</h2>
            <div className={styles.globalText}>
              To simplify and optimise global supply chains, enhancing
              operational efficiency and driving sustainable growth through
              smart procurement, streamlined logistics, and tailored supply
              chain solutions.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GlobalPartner;
